import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 pt-6 pb-20 md:px-8" }

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import FranchiseDayCarts from '@/components/franchise/FranchiseDayCarts.vue'
import FranchiseDayHeader from '@/components/franchise/FranchiseDayHeader.vue'
import FranchiseDayOrders from '@/components/franchise/FranchiseDayOrders.vue'
import FranchiseDayOverview from '@/components/franchise/FranchiseDayOverview.vue'
import FranchiseDayProducts from '@/components/franchise/FranchiseDayProducts.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import { useFranchiseDay } from '@/composables/useFranchiseDay'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { reportingMerchantId } from '@/helpers/franchiseMerchant'


export default {
  __name: 'FranchiseDay',
  setup(__props) {

const TABS = [
  { id: 'overview', name: 'Overview' },
  { id: 'orders', name: 'Orders' },
  { id: 'products', name: 'Products' },
  { id: 'carts', name: 'Unpaid carts' }
]

const TAB_COMPONENTS = {
  overview: FranchiseDayOverview,
  orders: FranchiseDayOrders,
  products: FranchiseDayProducts,
  carts: FranchiseDayCarts
}

const route = useRoute()
const router = useRouter()
const store = useStore()

const date = computed(() => route.params.date)
const dayPath = computed(() => `/dashboard/days/${date.value}`)

const { activeTab, sections } = useRouteTabs(TABS, dayPath)
const day = useFranchiseDay(date)

const locationPath = id => `${dayPath.value}/locations/${id}`

// This page always shows every location; choosing one opens that location's view of the same day.
const changeLocation = id => router.push(id ? `${locationPath(id)}/overview` : `${dayPath.value}/overview`)

// Opened while a location is active (from its calendar, or a link), the day opens for that location,
// so the page and the switcher agree.
// The franchise menu is not a location, so it opens the all locations day.
const activeLocationId = reportingMerchantId(store.state)
if (activeLocationId) router.replace(`${locationPath(activeLocationId)}/${activeTab.value}`)

return (_ctx, _cache) => {
  return (!_unref(activeLocationId))
    ? (_openBlock(), _createBlock(SecondaryNav, { key: 0 }, {
        top: _withCtx(() => [
          _createVNode(FranchiseDayHeader, {
            date: date.value,
            "back-link": "/dashboard",
            "back-name": "Dashboard",
            sections: _unref(sections),
            onChange: changeLocation
          }, null, 8, ["date", "sections"])
        ]),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(TAB_COMPONENTS[_unref(activeTab)]), { day: _unref(day) }, null, 8, ["day"]))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

}